import type Phaser from 'phaser';
import type { Facing } from '../../core';
import { mirrorStickPoint } from './stick-figure-model';
import type { StickPoint, StickViewModel } from './stick-figure-model';

export const STICK_BODY_PARTS = ['head', 'torso', 'leftArm', 'rightArm', 'leftLeg', 'rightLeg'] as const;
export const STICK_PLAYER_ACCENTS = [0x38bdf8, 0xf97316] as const; // 1P: Blue, 2P: Orange

export class StickCharacterRenderer {
  public constructor(private readonly graphics: Phaser.GameObjects.Graphics) {}
  public draw(view: StickViewModel, root: StickPoint, facing: Facing, alpha = 1, playerSlot: 0 | 1 = 0): void {
    const { profile, pose } = view; const transform = (value: StickPoint): StickPoint => mirrorStickPoint(root, value, facing);
    const head = transform(pose.head); const neck = transform(pose.neck); const hip = transform(pose.hip);
    const leftHand = transform(pose.leftHand); const rightHand = transform(pose.rightHand);
    const leftFoot = transform(pose.leftFoot); const rightFoot = transform(pose.rightFoot);
    const playerAccent = STICK_PLAYER_ACCENTS[playerSlot];

    // Player Identity: Ground ring marker
    this.graphics.lineStyle(2, playerAccent, alpha * 0.8).strokeEllipse(root.x, root.y - 2, 36, 12);

    // Character Body
    this.graphics.lineStyle(profile.lineWidth, profile.bodyColor, alpha).fillStyle(profile.bodyColor, alpha);
    this.graphics.strokeCircle(head.x, head.y, profile.headRadius).lineBetween(neck.x, neck.y, hip.x, hip.y)
      .lineBetween(neck.x, neck.y, leftHand.x, leftHand.y).lineBetween(neck.x, neck.y, rightHand.x, rightHand.y)
      .lineBetween(hip.x, hip.y, leftFoot.x, leftFoot.y).lineBetween(hip.x, hip.y, rightFoot.x, rightFoot.y);

    // Player Identity: Overhead indicator marker
    const markerY = head.y - profile.headRadius - 6;
    this.graphics.fillStyle(playerAccent, alpha * 0.95)
      .fillTriangle(head.x - 5, markerY - 8, head.x + 5, markerY - 8, head.x, markerY);

    // Character Accent
    this.graphics.fillStyle(profile.accentColor, alpha).fillCircle(rightHand.x, rightHand.y, profile.lineWidth * 0.8);
    if (pose.marker === 'DOCUMENTS') this.graphics.fillStyle(0xe8f4ff, alpha).fillRect(rightHand.x - 15, rightHand.y - 12, 30, 24)
      .lineStyle(2, profile.accentColor, alpha).strokeRect(rightHand.x - 15, rightHand.y - 12, 30, 24);
    if (pose.marker === 'DEADLINE') this.graphics.lineStyle(4, profile.accentColor, alpha).strokeRect(rightHand.x - 19, rightHand.y - 19, 38, 38)
      .lineBetween(rightHand.x - 19, rightHand.y - 4, rightHand.x + 19, rightHand.y - 4);
  }
}
